import { Button } from '@common/components/Button';
import Portal from '@common/components/Portal';
import { StickyBarContent } from '@common/components/StickyBar';
import { ReactNode } from 'react';
import { ButtonWrapper } from '../../components/ExperienceDetails/ExperienceDetails.styles';
import { useCurrentStep, usePackageConfiguration, useWizardNavigation } from '../../contexts';
import { StyledDateRangeIndicator } from '../FormSteps.styles';
import { useNextStepLabel } from './useNextStepLabel';

interface UseStepFooterOptions {
  isValid?: boolean;
  titleSuffix?: string;
  onButtonClick?: () => void;
  buttonText?: string;
}

export const useStepFooter = (options: UseStepFooterOptions = {}): ReactNode => {
  const { isValid, titleSuffix, onButtonClick, buttonText } = options;
  const { rate, journeyParams } = usePackageConfiguration();
  const { stickyBarId, handleNextStep } = useWizardNavigation();
  const { packageTotalPrice, isSubmitting } = useCurrentStep();
  const defaultButtonText = useNextStepLabel();

  const title = titleSuffix ? `${rate.title || ''} | ${titleSuffix}` : rate.title || '';

  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    handleNextStep();
  };

  return (
    <Portal selector={`#${stickyBarId}`}>
      <StickyBarContent
        name={title}
        subtitle={
          <StyledDateRangeIndicator
            fromDate={journeyParams.fromDate}
            toDate={journeyParams.toDate}
          />
        }
        displayedPrice={packageTotalPrice}
        button={
          <ButtonWrapper>
            <Button
              isPrimary
              type="button"
              onClick={handleClick}
              disabled={isValid === false || isSubmitting}
              isLoading={isSubmitting}
            >
              {buttonText || defaultButtonText}
            </Button>
          </ButtonWrapper>
        }
      />
    </Portal>
  );
};
